import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { enumData, loading } from '@/decorators';
import Throttling from '@/utils/throttling';
import { yesNoStatus } from '@/enum';
import { getAllListBulkRequest } from '@/utils/bulkRequest';
import { namespace } from 'vuex-class';
var User = namespace('user');
var throttling = new Throttling();

var ModalForm = function (_super) {
  __extends(ModalForm, _super);

  function ModalForm() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.loading = false;
    _this.packageReqEnum = [];
    _this.packageSelectEnum = [];
    _this.skuWrapperSourceEnum = [];
    _this.packageisNeedEnum = yesNoStatus;
    _this.currentWarehouseCode = '';
    _this.wrapperData = {};
    _this.formDataRule = {
      need_package: [{
        required: true,
        message: _this.t('请选择是否需要包材')
      }],
      package_select: [{
        required: true,
        message: _this.t('请选择包装选择方')
      }],
      sku_wrapper_source: [{
        required: true,
        message: _this.t('请选择包材归属')
      }],
      package_req: [{
        required: true,
        message: _this.t('请选择包材要求')
      }]
    };
    _this.formData = _this.initFormData();
    _this.formDataList = [];
    return _this;
  }

  Object.defineProperty(ModalForm.prototype, "isProductPrivateWrapper", {
    get: function get() {
      return this.customerInfo.is_product_private_wrapper;
    },
    enumerable: false,
    configurable: true
  });

  ModalForm.prototype.onWarehouseCodeChange = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (!(value && !this.wrapperData[this.currentWarehouseCode])) return [3, 2];
            _a = this.$set;
            _b = [this.wrapperData, this.currentWarehouseCode];
            return [4, this.queryWarpperList()];

          case 1:
            _a.apply(this, _b.concat([_c.sent()]));

            _c.label = 2;

          case 2:
            return [2];
        }
      });
    });
  };

  Object.defineProperty(ModalForm.prototype, "wrapperOptionList", {
    get: function get() {
      var _a;

      var _this = this;

      if (this.$util.isEmpty(this.currentWarehouseCode)) {
        return [];
      }

      var packageTypeEnum = (_a = {}, _a[this.$enum.warehouse.WrapperPackageType.PUBLIC] = this.$enum.product.SkuWrapperSourceEnum.PUBLIC, _a[this.$enum.warehouse.WrapperPackageType.PRIVATE] = this.$enum.product.SkuWrapperSourceEnum.PRIVATE, _a);
      return (this.wrapperData[this.currentWarehouseCode] || []).filter(function (item) {
        return (item.package_code.indexOf(_this.formData.package_code || '') > -1 || !_this.formData.package_code) && (String(_this.formData.package_req) === String(item.package_category) || _this.$util.isEmpty(_this.formData.package_req)) && _this.formData.sku_wrapper_source === packageTypeEnum[item.package_type];
      }).slice(0, 200);
    },
    enumerable: false,
    configurable: true
  });

  ModalForm.prototype.initFormData = function (data) {
    var originData = {
      warehouse_code: this.currentWarehouseCode,
      need_package: undefined,
      package_select: undefined,
      package_req: undefined,
      package_code: '',
      sku_wrapper_source: undefined
    };

    if (!data) {
      return originData;
    }

    for (var key in originData) {
      if (data.hasOwnProperty(key)) {
        originData[key] = data[key];
      }
    }

    return originData;
  };

  ModalForm.prototype.queryWrapperConfigInfo = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.wrapper.queryWrapperConfigInfo()];

          case 1:
            data = _a.sent().data;
            this.formDataList = data.map(function (item) {
              return {
                package_select: item.package_select,
                package_req: item.package_req,
                warehouse_code: item.warehouse_code,
                need_package: item.need_package,
                sku_wrapper_source: item.sku_wrapper_source,
                package_code: item.package_code
              };
            });
            return [2];
        }
      });
    });
  };

  ModalForm.prototype.queryWarpperList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, getAllListBulkRequest(function (param) {
              return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4, this.$api.wrapper.queryWrapperList(param)];

                    case 1:
                      data = _a.sent().data;
                      return [2, data.list];
                  }
                });
              });
            }, {
              warehouse_code: this.formData.warehouse_code,
              status: this.$enum.warehouse.WrapperStatus.PASS,
              page_size: 200,
              page_index: 1
            })];

          case 1:
            return [2, _a.sent()];
        }
      });
    });
  };

  ModalForm.prototype.productWrapperConfig = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.wrapper.productWrapperConfig(param)];

          case 1:
            _a.sent();

            this.$message.success(this.t('保存成功'));
            return [2];
        }
      });
    });
  };

  ModalForm.prototype.setCurrentFormData = function (value) {
    var _this = this;

    var item = this.$util.findItemByKeyValue(this.formDataList, value, 'warehouse_code');

    if (item) {
      this.formData = item;
    } else {
      this.formData = this.initFormData();
      var index = this.formDataList.findIndex(function (item) {
        return item.warehouse_code === value;
      });

      if (index === -1) {
        this.formDataList.push(this.formData);
      } else {
        this.formDataList[index] = this.formData;
      }
    }

    this.$nextTick(function () {
      var formDataRef = _this.$refs.formDataRef;
      formDataRef && formDataRef.clearValidate();
    });
  };

  ModalForm.prototype.handleSave = function () {
    return __awaiter(this, void 0, Promise, function () {
      var formDataRef, res, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            formDataRef = this.$refs.formDataRef;
            return [4, formDataRef.validate()];

          case 1:
            res = _a.sent();

            if (!res) {
              return [2];
            }

            data = this.formDataList.filter(function (item) {
              return typeof item.need_package !== 'undefined' && String(item.need_package) !== '';
            });
            return [4, this.productWrapperConfig({
              list: data
            })];

          case 2:
            _a.sent();

            this.$emit('success');
            this.$emit('update:visible', false);
            return [2];
        }
      });
    });
  };

  ModalForm.prototype.handleTabChange = function (value) {
    this.setCurrentFormData(value);
  };

  ModalForm.prototype.handlePackageCodeChange = function (packageCode) {
    var _this = this;

    var wrapper = (this.wrapperData[this.currentWarehouseCode] || []).find(function (item) {
      return item.package_code === _this.formData.package_code;
    });

    if (packageCode && wrapper && this.$util.isEmpty(this.formData.package_req)) {
      this.formData.package_req = Number(wrapper.package_category);
      var formDataRef = this.$refs.formDataRef;
      formDataRef.validateField('package_req', function () {});
    }
  };

  ModalForm.prototype.handlePackageReqChange = function () {
    this.formData.package_code = '';
  };

  ModalForm.prototype.handleNeedPackageChange = function () {
    this.formData.package_select = undefined;
    this.formData.package_req = undefined;
    this.formData.package_code = '';
    this.formData.sku_wrapper_source = undefined;
  };

  ModalForm.prototype.handlePackageSelectChange = function () {
    this.formData.package_req = undefined;
    this.formData.package_code = '';
  };

  ModalForm.prototype.handleSkuWrapperSourceChange = function () {
    this.formData.package_code = '';
  };

  ModalForm.prototype.handleClose = function () {
    this.$emit('update:visible', false);
  };

  ModalForm.prototype.handleVisibleChange = function () {
    return __awaiter(this, void 0, Promise, function () {
      var formDataRef;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.visible) return [3, 2];
            return [4, this.queryWrapperConfigInfo()];

          case 1:
            _a.sent();

            this.currentWarehouseCode = this.rowData.warehouseList ? this.rowData.warehouseList[0].warehouse_code : '';
            this.setCurrentFormData(this.currentWarehouseCode);
            return [3, 3];

          case 2:
            formDataRef = this.$refs.formDataRef;
            formDataRef && formDataRef.clearValidate();
            _a.label = 3;

          case 3:
            return [2];
        }
      });
    });
  };

  ModalForm.prototype.created = function () {};

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], ModalForm.prototype, "visible", void 0);

  __decorate([Prop({})], ModalForm.prototype, "rowData", void 0);

  __decorate([enumData('Wrapper/PackageReqEnum')], ModalForm.prototype, "packageReqEnum", void 0);

  __decorate([enumData('Wrapper/PackageSelectEnum')], ModalForm.prototype, "packageSelectEnum", void 0);

  __decorate([enumData('Wrapper/SkuWrapperSourceEnum')], ModalForm.prototype, "skuWrapperSourceEnum", void 0);

  __decorate([User.State('customerInfo')], ModalForm.prototype, "customerInfo", void 0);

  __decorate([Watch('currentWarehouseCode', {
    immediate: true
  })], ModalForm.prototype, "onWarehouseCodeChange", null);

  __decorate([loading('loading')], ModalForm.prototype, "productWrapperConfig", null);

  __decorate([Watch('visible', {
    deep: true,
    immediate: true
  })], ModalForm.prototype, "handleVisibleChange", null);

  ModalForm = __decorate([Component], ModalForm);
  return ModalForm;
}(Vue);

export default ModalForm;